import {useChannelService, useConfirmModal} from "@hosttools/frontend";
import {ModalToken} from "@hosttools/frontend/components";
import type {Listing} from "@hosttools/frontend/models/listing";
import React from "react";

function useConfirmCloseChannelConnector(listing: Listing) {
    const channelService = useChannelService();

    const [onRemoveChannel, updateConfirmModal] = useConfirmModal({
        title: "Disable",
        message: "Are you sure you want to disable this listing?",
        buttonText: "Delete",
        data: "",
        onOk: async channel => {
            if (channel) {
                const channelObject = listing.channels.ChannelConnector.channels?.find(
                    c => c.channel === channel
                );
                if (channelObject?.channelABB) {
                    await channelService.post("/closeChannel", {
                        listingID: listing._id,
                        channelABB: channelObject.channelABB
                    });
                }
            }
        }
    });

    return React.useCallback(
        (channel: string) => {
            onRemoveChannel();
            updateConfirmModal({
                title: `Disable ${channel}`,
                data: channel,
                message: (
                    <>
                        Are you sure you want to disable this listing on{" "}
                        <ModalToken>{channel}</ModalToken>?
                    </>
                )
            });
        },
        [onRemoveChannel, updateConfirmModal]
    );
}

export default useConfirmCloseChannelConnector;
